import React, { Component } from 'react';

import { FooterHelp, Link } from '@shopify/polaris';
import intl from '../../i18n/intl';

class SheetExample extends Component {
    state = {
      loading:true
    };
    
  //进入页面调用接口
  componentDidMount () {
    setTimeout(()=>{
      this.setState({
        loading:false
      })
    },1000)
  }
    
  render() {
    const {loading} = this.state;
    const {helpCenterLink, helpCenterText} = this.props;
    const footerContent = loading ? <div style={{height:'60px'}}></div> : <div style={{height:'60px',display:'flex',justifyContent:'center'}}>
    <FooterHelp>{intl.get("Learn more about")} <Link url={helpCenterLink} external={true}>{helpCenterText}</Link> by  <Link url={'https://www.channelwill.com/'} external={true}>Channelwill</Link></FooterHelp>
</div>
    return  (helpCenterLink && helpCenterText !== '') &&  footerContent;
  }
}


export default SheetExample;